import type { YammerCache } from '@ms/yammer-data/dist/cache';
import { MemoryCache } from '@ms/yammer-data/dist/cache';

let tokenCache: YammerCache | undefined;

type InitializeAuthTokenCache = () => void;
export const initializeAuthTokenCache: InitializeAuthTokenCache = () => {
  tokenCache = new MemoryCache();
};

type GetAuthTokenCache = () => YammerCache | undefined;
export const getAuthTokenCache: GetAuthTokenCache = () => tokenCache;
